module.exports = __webpack_public_path__ + "img/273.8d180b3a.png";